/**
 * 墨 · 阅读 - 轻量入口
 */

import { startApp } from './appOrchestratorModule.js';

const DEV_FIX_RELOAD_KEY = 'ink_dev_reload_dict_fix_20260301_v5';

if (import.meta.env.DEV && typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    if (!window.sessionStorage.getItem(DEV_FIX_RELOAD_KEY)) {
      window.sessionStorage.setItem(DEV_FIX_RELOAD_KEY, '1');
      window.location.reload();
    }
  } catch (error) {
  }

  navigator.serviceWorker.getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().catch(() => {});
      });
    })
    .catch(() => {});

  if ('caches' in window) {
    window.caches.keys()
      .then((keys) => Promise.all(keys.map((key) => window.caches.delete(key))))
      .catch(() => {});
  }
}

startApp();
